import React from 'react'
import SVG from 'react-inlinesvg'
import {toAbsoluteUrl} from '../AssetHelpers'
interface Props extends React.HTMLAttributes<HTMLSpanElement> {
  className?: string
  path: string
  svgClassName?: string
}

const KTSVG: React.FC<Props> = ({className = '', path, svgClassName = 'mh-50px', ...rest}) => {
  return (
    <span className={`svg-icon ${className}`} {...rest}>
      <SVG src={toAbsoluteUrl(path)} className={svgClassName}></SVG>
    </span>
  )
}

export {KTSVG}
